import { AccessToken, FormDataKeyValuePair, OAuthIntegration } from '@glueapp/graph-types';

const todoistOAuthBaseUrl = 'https://todoist.com/oauth';
const todoistAuthorizeUrl = `${todoistOAuthBaseUrl}/authorize`;
const todoistAccessTokenUrl = `${todoistOAuthBaseUrl}/access_token`;
const todoistScopes = 'data:read_write';

export const TodoistIntegration: OAuthIntegration<AccessToken, { TODOIST_CLIENT_ID: string; TODOIST_CLIENT_SECRET: string }, {}> = {
    integrationType: 'oauth',
    provider: 'todoist',
    allowedDomains: ['api.todoist.com'],
    getAccessTokenUrl(): string {
        return todoistAccessTokenUrl;
    },
    getAuthorizationUrl(oauthState, redirectUrl, secrets): string {
        return `${todoistAuthorizeUrl}?client_id=${secrets.TODOIST_CLIENT_ID}&scope=${todoistScopes}&state=${oauthState}`;
    },
    getGrantTypeTokenFormData(queryParams, redirectUri, secrets): FormDataKeyValuePair[] {
        return [
            { key: 'client_id', value: secrets.TODOIST_CLIENT_ID },
            { key: 'client_secret', value: secrets.TODOIST_CLIENT_SECRET },
            { key: 'code', value: queryParams.code },
        ];
    },
    requiredSecrets: ['TODOIST_CLIENT_ID', 'TODOIST_CLIENT_SECRET'],
    renderOptionLabel: () => 'Todoist',
    resolveTokenAndMetaDataFromSuccessResponse(responseData) {
        return { tokens: { access_token: responseData.access_token }, metaData: {} };
    },
};
